'use client';

import { type AuthedUser } from '@bells/schema/models/auth';
import { createContext, type Dispatch, type SetStateAction } from 'react';

export interface UserContextState {
  currentUser: AuthedUser | undefined;
  setCurrentUser: Dispatch<SetStateAction<AuthedUser | undefined>> | undefined;
  accessToken: string | undefined;
  setToken: (accessToken: string, expiresIn: string) => void;
  logout: () => void;
  isAuthed: boolean;
  openSettings: boolean;
  setOpenSettings: (val: boolean) => void;
  refresh: (callback?: () => void) => void;
}

// Define a default context value that matches the shape of UserContextState
export const defaultContextValue: UserContextState = {
  currentUser: undefined,
  setCurrentUser: undefined,
  accessToken: undefined,
  setToken: () => {},
  logout: () => {},
  setOpenSettings: () => {},
  isAuthed: false,
  openSettings: false,
  refresh: () => {},
};

// Context creation with a default value that matches the expected shape
export const UserContext = createContext<UserContextState>(defaultContextValue);
